import { parse } from "graphql";
export const getExpertStats = params => {
  let args = {
    type: "$groupByDate: GroupByDate!, $startDate: String!, $endDate: String!,$stats:[String!]!",
    values: "groupByDate: $groupByDate, startDate: $startDate, endDate: $endDate,stats:$stats"
  };
  if (params.expertGroupName !== null) {
    args = {
      type: "$groupByDate: GroupByDate!, $startDate: String!, $endDate: String!,$expertGroupName:String!,$stats:[String!]!",
      values: "groupByDate: $groupByDate, startDate: $startDate, endDate: $endDate,expertGroupName:$expertGroupName,stats:$stats"
    };
  }
  return parse(`
        query getStats(${args.type}){
            getStats(${args.values}) {
                metric{
                    name
                    metricData {
                        date
                        value
                    }
                }
            }
        }
`);
};